import { T_CONTACT_US_FORM_PAGE_CONSTANTS } from './TYPES'

const DE_CONTACT_US_FORM_PAGE_CONSTANTS: T_CONTACT_US_FORM_PAGE_CONSTANTS = {
  FULL_NAME_LABEL: 'Vollständiger Name',
  FULL_NAME_PLACEHOLDER: 'Geben Sie Ihren vollständigen Namen ein',
  FULL_NAME_ERRORS_REQUIRED: 'Vollständiger Name ist erforderlich.',
  EMAIL_ID_LABEL: 'E-Mail-Adresse',
  EMAIL_ID_PLACEHOLDER: 'Geben Sie Ihre E-Mail-Adresse ein',
  EMAIL_ID_ERRORS_REQUIRED: 'E-Mail-Adresse ist erforderlich.',
  EMAIL_ID_ERRORS_INVALID: 'Geben Sie eine gültige E-Mail-Adresse ein.',
  SUBJECT_LABEL: 'Betreff',
  SUBJECT_PLACEHOLDER: 'Geben Sie einen Betreff ein',
  SUBJECT_ERRORS_REQUIRED: 'Betreff ist erforderlich.',
  MESSAGE_LABEL: 'Ihre Nachricht',
  MESSAGE_PLACEHOLDER: 'Geben Sie Ihre Nachricht ein',
  MESSAGE_ERRORS_REQUIRED: 'Nachricht ist erforderlich.',
  SEND_CTA_TEXT: 'Senden'
}

export default DE_CONTACT_US_FORM_PAGE_CONSTANTS
